export default function LaunchBanner() {
  return (
    <div className="fixed top-0 inset-x-0 z-[60] h-11 bg-brand-red text-white flex items-center justify-center px-4 text-center" data-testid="launch-banner">
      <p className="text-xs sm:text-sm font-medium tracking-wide">
        Launching March 1, 2027 — prebooking open now, paid classes start March 2, 2027
      </p>
    </div>
  );
}
